<template>
  <div
    :class="{ 'isEnhanced': result.enhanced }"
    class="Search Search--reviews"
  >
    <div :class="[{ 'isFeatured': featured }, 'Search-content']">
      <figure class="Search-companyLogo">
        <a
          :href="result.url"
          :title="result.company.name + ' ' + decodeHtml(result.title) "
          class="company-search-logo"
        >
          <img
            v-if="result.company.small_logo"
            :src="result.company.small_logo"
            :alt="result.company.name"
            width="58"
            height="58"
            loading="lazy"
          >
          <img
            v-else
            :src="defaultLogo"
            :alt="result.company.name"
            width="58"
            height="58"
            loading="lazy"
          >
        </a>
      </figure>

      <a
        :href="result.url"
        :title="result.company.name + ' ' + decodeHtml(result.title) "
        class="Search-descriptions"
      >
        <span
          :href="result.url"
          class="Job-title"
        >
          <h2
            v-if="result.title"
            :title="decodeHtml(result.title)"
            class="Job-titleHeader"
            v-html="result.title"
          />
          <h2
            v-else
            :title="decodeHtml(result.title)"
            class="Job-titleHeader"
            v-html="result.title"
          />
        </span>

        <ul class="Search-links">
          <li class="company"><span class="far fa-briefcase" /> {{ result.company.name }}</li>
          <li class="deadline"><span class="far fa-calendar-alt" /> {{ result.job_type }}</li>
        </ul>

        <div class="reviews">
          <div class="review-container">
            <rating
              :model-value="roundNumber(result.rating, 1)"
              :read-only="true"
            />
          </div>
        </div>
        <p
          v-if="result.quote"
          class="review--quote"
          v-html="result.quote"
        />

        <div
          v-if="result.company.is_ted && result.company.ted_details.paid"
          class="Search-ted"
        >
          <tooltip>
            <template #trigger>
              <span
                class="Tag Tag--purple Tag--small"
              >
                <i class="far fa-trophy" /> {{ result.company.ted_label }}
              </span>
            </template>
            <template #tip>
              <span> {{ tooltipForTopEmployer }}</span>
            </template>
          </tooltip>
        </div>
      </a>

      <div class="icon-cta">
        <save-item-button
          :id="result.id"
          :company-id="result.company.id"
          :company-name="result.company.name"
          :title="decodeHtml(result.title)"
          type="reviews"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import SaveItemButton from '@/components/common/save-item-button.vue';
import ReviewRatingStars from '@/components/form/rating.vue';
import Tooltip from '../../common/rmp-tool-tip.vue';
import { roundNumber } from '@/filters';

export default {
  name: 'ReviewResult',
  components: {
    SaveItemButton,
    rating: ReviewRatingStars,
    tooltip: Tooltip,
  },

  props: {
    result: {
      type: Object,
      required: true,
      default() {
        return {};
      },
    },
    featured: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      roundNumber,
    };
  },

  computed: {
    ...mapGetters('entities', {
      getCdnImagePath: 'getCdnImagePath',
    }),
    tooltipForTopEmployer() {
      return `${this.result.company.ted_details.rank_ordinal} in ${this.result.company.ted_details.type_of_rank_name} table`;
    },
    defaultLogo() {
      return this.getCdnImagePath('/website/company_placeholder.jpg');
    },
  },

  methods: {
    decodeHtml(str) {
      const textArea = document.createElement('textarea');
      textArea.innerHTML = str;
      return textArea.value;
    },
  },
};
</script>

<style scoped>
    .SearchResult-wrapper {
        margin-bottom: 20px;
        padding-bottom: 20px;
        border-bottom: 1px solid #d1d1d1;
    }

    .SearchResult-review {
        display: flex;
        align-content: space-between;

    }

    .SearchResult-reviewLogo {
        flex: 0 0 75px;
        margin-right: 30px;

        img {
            width: 75px;
        }
    }

    .SearchResult-reviewContent {
        flex: 1;

        ul {
            margin-bottom: 0;
            list-style-type: none;
            display: flex;
        }
        li {
            margin-right: 10px;
        }
    }

    .SearchResult-reviewTitle {
        font-size: 18px;
        margin: 0;
    }

    .SearchResult-reviewQuote {
        margin-bottom: 0;
    }

    .SearchResult-shortlist {
        flex: 0 0 50px;
        text-align: right;
    }

    .SearchResult-reviewRatingScore {
        padding: 5px;
        background: #d1d1d1;
    }
</style>
